import styled from 'styled-components';

import { useTranslation } from '@ciam/i18n';
import { pageRedirects } from '@features/shared';

export const ForgotPasswordLink = () => {
  const { t } = useTranslation('login');

  return <Button onClick={pageRedirects.forgotPasswordPage}>{t('form.fields.forgot-password-link.title')}</Button>;
};

const Button = styled.a`
  ${({ theme }) => theme.getFontStyle('samsung-400-14')};
  color: ${({ theme }) => theme.getColor('primary', 'default')};
  text-align: right;
  text-decoration: none;
  margin: -0.6rem 0 2.4rem 0;
  cursor: pointer;
`;
